import { patchAxiosConfig } from "@/utils/request";
import request from "@/utils/request";

export function all(id) {
  return request.get(`/tickets?loyalty`, { data: null });
}

export function get(id) {
  return request.get(`/tickets/${id}?loyalty`, { data: null });
}

export function share(id) {
  return request.patch(`/tickets/${id}/share?loyalty`, {}, patchAxiosConfig);
}

export function unshare(id) {
  return request.patch(`/tickets/${id}/unshare?loyalty`, {}, patchAxiosConfig);
}

export function shareBenefits(id) {
  return new Promise(resolve => {
    resolve({
      data: [
        "Imparte-ti biletul\u00a0si vei castiga mai multe puncte, mai repede.\u00a0",
        "Daca\u00a0imparti acest bilet cu prietenii din avionul tau care nu au bilet,\u00a0acestia\u00a0vor putea\u00a0plasa comenzi in baza biletului tau.",
        "Vei primi 1 punct la fiecare 10 Euro cheltuiti de prieteni\u00a0la comenzile cu acumulare de puncte, plasate in baza biletului tau. ",
      ],
    });
  });
}

export function history(id, params) {
  return request.get(`/tickets/${id}/history?loyalty`, { params });
}

export function upload() {
  return request.post(`/tickets/upload?loyalty`);
}

export const shareRequest = {
  all(id, params) {
    return request.get(`/tickets/${id}/share-ticket-requests?loyalty`, {
      params,
    });
  },

  create(id) {
    return request.post(`/share-ticket-requests?loyalty`, {
      requestedTicketId: id,
    });
  },

  cancel(code) {
    return request.patch(
      `/share-ticket-requests/${code}/revoke?loyalty`,
      {},
      patchAxiosConfig
    );
  },

  activate(code, usageLimit) {
    return request.patch(
      `/share-ticket-requests/${code}/approve?loyalty`,
      {
        usageLimit,
      },
      patchAxiosConfig
    );
  },

  reject(code) {
    return request.patch(
      `/share-ticket-requests/${code}/reject?loyalty`,
      {},
      patchAxiosConfig
    );
  },

  sendReminder(code) {
    return request.patch(
      `/share-ticket-requests/${code}/send-reminder?loyalty`,
      {},
      patchAxiosConfig
    );
  },
};
